export const breakpoints = {
  mobile_1: 0,
  mobile_2: 375,
  tablet_1: 600,
  tablet_2: 768,
  desktop_1: 1024,
  desktop_2: 1400,
  desktop_3: 1920,
};

export const mobile = window.matchMedia(
  `(max-width: ${breakpoints.tablet_2}px)`
).matches;

export const pendant_prefix = ['chains:'];
export const algolia_config = {
  active: true,
  active_search: window.algolia_search_engine === true,
  app_id: '1H66PN378I',
  api_key: '9b205c0950858ae70c1c344caa4d7643',
  // api_key: '0637d8f30982e73bb4d6caa12e719545',
  get predictive_search_active() {
    return window.algolia_predictive_search_suggestions === true;
  },
  indexes: {
    collections: 'shopify_collections',
    products: 'shopify_products',
    get query_suggestions() {
      return (
        window.algolia_query_suggestions_index ||
        'shopify_products_query_suggestions'
      );
    },
  },
};

export const CART_BUNDLE_PREFIX = 'Bundle ';

export const priceInternationalEnpoint =
  'https://price-intrnational-global-e-1a1c17044ee3.herokuapp.com';
// export const priceInternationalEnpoint = "http://localhost:5000"
export const priceInternationalEnpointAuth =
  'b2Z0RXFWS0dYbG9EeW90Okg0OE9KNXZzdjZSb05OOA';
export const newsletterAuth = 'b2Z0RXFWS0dYbG9EeW90Okg0OE9KNXZzdjZSb05OOA==';

export const urls = {
  cart: window?.shopifyRoutes?.cart ? window.shopifyRoutes.cart : '/cart',
};

export const metaobjectsEndpoint =
  'https://metaobjects-ded4f93d27d2.herokuapp.com';
// export const priceInternationalEnpoint = "http://localhost:5000"
export const metaobjectsEndpointAuth =
  'b2Z0RXFWS0dYbG9EeW90Okg0OE9KNXZzdjZSb05OOA==';

export const tryNowCookieName = '_tn_gate';
export const tryNowTagProductEligible = 'TryNowAutomated';

export const hook = {
  productFullBarBreakpoint: document.querySelector(
    '.product-full__bar__breakpoint'
  ),
};

/**
 * Cookie namespace prefixes.
 *
 * Add new first-party cookie names under `cookiesName` and compose them from
 * these prefixes. Cookie reads/writes should import `cookiesName` instead of
 * hardcoding string names at the call site.
 *
 * Namespaces:
 * - `general_`: shared app cookies that do not fit a narrower domain.
 * - `user_`: user/session context such as location, country, or currency.
 * - `offer_`: promotion, gift, free item, and cart-offer state.
 * - `ux_`: experience flags, experiments, and UI state.
 * - `external`: third-party cookie names that should stay unprefixed.
 */
export const cookiePrefixes = {
  general: 'general_',
  usee: 'user_',
  offer: 'offer_',
  ux: 'ux_',
};

export const cookiesName = {
  //external
  external: {
    dy: {
      dyid: `_dyid`,
      dyjsession: `_dyjsession`,
    },
  },
  //general
  general: {
    signinMail: `${cookiePrefixes.general}signin-mail`,
    zendeskWidgetAlive: `${cookiePrefixes.general}ZendeskWidgetAlive`,
  },
  //offers
  offer: {
    version: `${cookiePrefixes.offer}version`,
    freeItemByParameterPrefix: `${cookiePrefixes.offer}gld-parameter_`,
    freeItemRemoveIntentional: `${cookiePrefixes.offer}free-item-remove-intentional`,
  },
  //user
  user: {
    country: `${cookiePrefixes.usee}country`,
    currency: `${cookiePrefixes.usee}currency`,
    location: `${cookiePrefixes.usee}gldLocation`,
  },
  //ux
  ux: {
    mainMenuDesktopShopAllNavTest: `${cookiePrefixes.ux}MainMenuDesktopShopAllNavTest`,
    pdpRedesignTestActive: `${cookiePrefixes.ux}PdpRedesignTestActive`,
    pdpRedesignGalleryTestActive: `${cookiePrefixes.ux}PdpRedesignGalleryTestActive`,
  },
};

export const cookieExpiration = {
  // [cookiesName.offer.freeItemByParameterPrefix]: new URL(window.location.href).searchParams.get('cookie-gwp-expire-test') || 3,
  [cookiesName.offer.freeItemByParameterPrefix]: 3,
};
